/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { VisitStatusViewModel } from './VisitStatusViewModel'; 

export function getVisitStatusOptions(visitId: string, onSuccess?: (result: VisitStatusViewModel) => void) {
	return queryOptions({
		queryKey: ['visit-status', visitId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/visits/queries/getvisitstatus/' + visitId;
			const resp = await axios.get<VisitStatusViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(visitId)
	});
}